@if (!showPreview()) {
  <button
    mat-icon-button
    class="camera-calendar__toggle"
    (click)="showPreview.set(true)"
    [matTooltip]="showPreviewLabel()"
  >
    <mat-icon color="accent">calendar_month</mat-icon>
  </button>
} @else {
  <mat-card class="camera-calendar">
    <mat-card-title class="camera-calendar__title">
      Preview
      <button
        mat-icon-button
        class="camera-calendar__toggle"
        (click)="showPreview.set(false)"
        [matTooltip]="showPreviewLabel()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content>
      <div class="camera-calendar__content">
        <div class="camera-calendar__view">
          @if (step() === 2) {
            <rc-camera-calendar-day-view
              [selectedDate]="selectedDate()"
              (dayChange)="onDayChange($event)"
              (back)="onDayBackClicked()"
            ></rc-camera-calendar-day-view>
          }
          @if (step() === 1) {
            <rc-camera-calendar-month-view
              (dayChange)="onDayChange($event)"
              (monthChange)="onMonthChange($event)"
              [selectedDate]="selectedDate()"
              (back)="onMonthBackClicked()"
            ></rc-camera-calendar-month-view>
          }
          @if (step() === 0) {
            <rc-camera-calendar-year-view
              (monthChange)="onMonthChange($event)"
              [selectedDate]="selectedDate()"
              (yearChange)="onYearChange($event)"
            ></rc-camera-calendar-year-view>
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>
}
